import React from 'react';
import { Box, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export function StartNodeFields ({localNodeData, updateNodeData, accountList}) {
  
    return (
        <>
            <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
                Opciones de Cuenta
            </Typography>
            <FormControl fullWidth>
                <InputLabel id="account-select-label">Cuenta</InputLabel>
                <Select
                    labelId="account-select-label"
                    value={localNodeData.accountId || ''}
                    label="Cuenta"
                    onChange={(e) => {
                    updateNodeData('accountId', e.target.value);
                    // Limpiar la selección de plantilla al cambiar de cuenta
                    }}
                >
                {accountList.map((account) => (
                    <MenuItem key={account.id} value={account.id}>
                        {account.number}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
            </Box>
        </>
    );
}